interface HasNoAssociatedPlayersArgs {
  /** True once /users/me/players3 has resolved (success or error). */
  loadedPlayers: boolean
  /** Number of player profiles associated with the current user. */
  playerCount: number
}

/**
 * Whether the user has finished loading players and has none associated.
 *
 * Gates the Profile screen's empty state: the result is only `true` once the
 * fetch has completed, so the empty state never flashes during the initial
 * load.
 */
export const hasNoAssociatedPlayers = ({
  loadedPlayers,
  playerCount,
}: HasNoAssociatedPlayersArgs): boolean => loadedPlayers && playerCount === 0
